var blockSectionScrollSnap = document.querySelector('.featured-header.block-section--scroll-snap');

if (blockSectionScrollSnap) {
  var scrollSnapContainer = blockSectionScrollSnap.querySelector('.scroll-snap-container');
  var timeoutColourSideLeft;
  var timeoutColourSideRight;
  var timeoutPieChartOverlay;
  var timeoutChartInLeft;
  var timeoutChartInRight;
  var timeoutChartInLeftFast;
  var timeoutChartInRightFast;
  var timeoutPieChartPosition;
  var timeoutScrollSnaptOverlay;
  var timeoutScrollOverflowHidden;

  function initAddAnimationDelay() {
    const wysiwygElements = scrollSnapContainer.querySelectorAll('.wysiwyg');

    wysiwygElements.forEach((wysiwyg) => {
      var datas = wysiwyg.dataset;
      let delay = 0;

      const h2AndPElements = wysiwyg.querySelectorAll('h2, p');

      h2AndPElements.forEach((element) => {
        element.classList.add(datas['animateIn'], datas['animateOut']);

        element.style.animationDelay = `${delay}s`;

        delay += parseFloat(datas['delay']);
      });
    });
  }

  function initSetSectionActive() {
    let callback = (entries, obs) => {
      entries.forEach((entry) => {
        var colourCorner = entry.target.dataset['colourCorner'];
        var colourCornerIn = entry.target.dataset['colourCornerIn'];
        var colourCornerPosition = entry.target.dataset['colourCornerPosition'];
        var colourCornerColor = entry.target.dataset['colourCornerColor'];
        var colourSide = entry.target.dataset['colourSide'];
        var colourSideOut = entry.target.dataset['colourSideOut'];

        var pieChart = entry.target.dataset['pieChart'];
        var pieChartPosition = entry.target.dataset['pieChartPosition'];

        var colourCornerLeft = blockSectionScrollSnap.querySelector('.colour-corner-left');
        var colourCornerInner = blockSectionScrollSnap.querySelector('.colour-corner-inner');
        var colourCornerLeftSVG = blockSectionScrollSnap.querySelector('.colour-corner-left svg');
        var colourSideLeft = blockSectionScrollSnap.querySelector('.colour-side-left');
        var colourSideRight = blockSectionScrollSnap.querySelector('.colour-side-right');

        var pieChartOverlay = blockSectionScrollSnap.querySelector('.pie-chart-overlay');
        var scrollSnaptOverlay = blockSectionScrollSnap.querySelector('.scroll-snap-overlay');

        clearTimeout(timeoutColourSideLeft);
        clearTimeout(timeoutColourSideRight);
        clearTimeout(timeoutPieChartOverlay);

        if (!entry.isIntersecting) {
          if (window.innerWidth >= 922) {
            entry.target.classList.remove('active');
            entry.target.classList.remove('fade-out');

            const colourCornerLeftClasses = [
              'active',
              'slide-out-top',
              'slide-out-left',
              'fade-out-corner',
              'slide-out-top-corner',
              'scale-in-center-corner'
            ];

            const colourCornerInnerClasses = [
              'slide-tr-corner',
              'slide-left-corner',
              'corner-righ-flip',
              'half-width-corner'
            ];

            const colourSideLeftClasses = ['active', 'slide-out-top-corner', 'fade-out-top', 'fade-out-bottom'];
            const colourSideRightClasses = ['active', 'slide-out-top-corner', 'fade-out-top', 'fade-out-bottom'];
            const pieChartOverlayClasses = ['active'];

            colourCornerLeftClasses.forEach((cls) => {
              colourCornerLeft.classList.remove(cls);
            });

            colourCornerInnerClasses.forEach((cls) => {
              colourCornerInner.classList.remove(cls);
            });

            colourSideLeftClasses.forEach((cls) => {
              colourSideLeft.classList.remove(cls);
            });

            colourSideRightClasses.forEach((cls) => {
              colourSideRight.classList.remove(cls);
            });

            pieChartOverlayClasses.forEach((cls) => {
              pieChartOverlay.classList.remove(cls);
            });

            colourCornerLeftSVG.removeAttribute('class');
          }
        } else {
          entry.target.classList.add('active');

          setTimeout(function () {
            if (colourCornerIn) {
              colourCornerLeftSVG.classList.add(colourCornerIn);
            }
            if (colourCornerColor) {
              colourCornerInner.style.color = colourCornerColor;
            }
            if (colourCornerPosition) {
              colourCornerInner.classList.add(colourCornerPosition);
            }

            if (pieChartPosition) {
              if (pieChartPosition == 'chart-in-left') {
                pieChartOverlay.classList.remove('chart-in-right');
              }
              if (pieChartPosition == 'chart-in-right') {
                pieChartOverlay.classList.add(pieChartPosition);
              }
            }

            if (colourCorner == 'true') {
              colourCornerLeft.classList.add('active');
            } else {
              colourCornerLeft.classList.remove('active');
            }
            if (colourSide == 'left') {
              timeoutColourSideLeft = setTimeout(function () {
                colourSideLeft.classList.add('active');
                colourSideLeft.classList.add(colourSideOut);
              }, 1500);
            } else {
              colourSideLeft.classList.remove('active');
            }
            if (colourSide == 'right') {
              timeoutColourSideRight = setTimeout(function () {
                colourSideRight.classList.add('active');
                colourSideRight.classList.add(colourSideOut);
              }, 1500);
            } else {
              colourSideRight.classList.remove('active');
            }
            if (pieChart == 'true') {
              pieChartOverlay.classList.add('active');
            } else {
              const pieChartOverlayClasses = [
                'active',
                'chart-in-left',
                'chart-in-right',
                'slide-to-left',
                'slide-to-right',
                'fade-out',
                'no-animation-slide-in-bottom'
              ];
              pieChartOverlayClasses.forEach((cls) => {
                pieChartOverlay.classList.remove(cls);
              });
            }

            if (window.innerWidth >= 922) {
              scrollSnaptOverlay.classList.add('active');
              clearTimeout(timeoutScrollSnaptOverlay);
              timeoutScrollSnaptOverlay = setTimeout(function () {
                scrollSnaptOverlay.classList.remove('active');
              }, 0);

              if (
                entry.target.classList.value.indexOf('section--first') > -1 ||
                entry.target.classList.value.indexOf('section--last') > -1
              ) {
                var header = document.querySelector('header');
                var blockSectioncalloutAnimation = document.querySelector(
                  '.featured-header.block-section--callout-animation'
                );
                var yCoord = blockSectionScrollSnap.offsetTop - header.offsetHeight;
                if (blockSectioncalloutAnimation) {
                  yCoord = yCoord + 30;
                }
                window.scrollTo(0, yCoord);
                document.body.classList.add('scroll-overflow-hidden');
              }
            }
          }, 0);
        }
      });
    };

    let options = {
      threshold: 0.25
    };

    if (window.innerWidth >= 922) {
      options = {
        threshold: 0.5
      };
    }

    let observer = new IntersectionObserver(callback, options);
    scrollSnapContainer.querySelectorAll('.section').forEach((section) => observer.observe(section));
  }

  function initOnScrollAnimation() {
    var header = document.querySelector('header');
    var blockSectioncalloutAnimation = document.querySelector('.featured-header.block-section--callout-animation');
    var yCoord = blockSectionScrollSnap.offsetTop - header.offsetHeight;
    if (blockSectioncalloutAnimation) {
      yCoord = yCoord + 30;
    }

    scrollSnapContainer.addEventListener('scroll', function () {
      // console.log('🚀 ~ file: featured-header-scroll-snap.js:219 ~ scroll:', 'scroll');
      var scrollTop = this.scrollTop;
      var columnsActive = scrollSnapContainer.querySelector('.section.active');
      // var columnsFirst = scrollSnapContainer.querySelector('.section--first');
      // var columnsLast = scrollSnapContainer.querySelector(' .section--last');
      var colourCornerLeft = blockSectionScrollSnap.querySelector('.colour-corner-left');
      var colourSideLeft = blockSectionScrollSnap.querySelector('.colour-side-left');
      var colourSideRight = blockSectionScrollSnap.querySelector('.colour-side-right');
      var pieChartOverlay = blockSectionScrollSnap.querySelector('.pie-chart-overlay');
      var columnsActiveOffsetTop = columnsActive ? columnsActive.offsetTop : 0;
      // var columnsFirstOffsetTop = columnsFirst ? columnsFirst.offsetTop : 0;
      // var columnsLastOffsetTop = columnsLast ? columnsLast.offsetTop : 0;
      var scrollSnaptOverlay = blockSectionScrollSnap.querySelector('.scroll-snap-overlay');

      clearTimeout(timeoutScrollOverflowHidden);
      timeoutScrollOverflowHidden = setTimeout(function () {
        if (columnsActive) {
          scrollSnaptOverlay.classList.add('active');
          if (
            columnsActive.classList.value.indexOf('section--first') == -1 &&
            columnsActive.classList.value.indexOf('section--last') == -1
          ) {
            document.body.classList.add('scroll-overflow-hidden');
          }
        }
      }, 0);

      clearTimeout(timeoutScrollSnaptOverlay);
      timeoutScrollSnaptOverlay = setTimeout(function () {
        scrollSnaptOverlay.classList.remove('active');
      }, 0);

      if (scrollTop > columnsActiveOffsetTop && columnsActive) {
        var colourCorner = columnsActive.dataset['colourCorner'];
        var colourCornerOut = columnsActive.dataset['colourCornerOut'];
        var pieChartOut = columnsActive.dataset['pieChartOut'];

        columnsActive.classList.add('fade-out');
        colourCornerLeft.classList.add('fade-out');

        colourSideLeft.classList.add('fade-out-top');
        colourSideRight.classList.add('fade-out-top');

        pieChartOverlay.classList.add('fade-out-top');

        scrollSnapContainer.querySelectorAll('.section').forEach((element) => {
          if (element.classList.value.indexOf('active') > -1) {
            element.classList.remove('fade-out');
          }
        });

        clearTimeout(timeoutChartInLeft);
        clearTimeout(timeoutChartInRight);

        setTimeout(function () {
          if (colourCorner == 'true') {
            colourCornerLeft.classList.add('active');
          } else {
            colourCornerLeft.classList.remove('active');
          }
          if (colourCornerOut) {
            colourCornerLeft.classList.add(colourCornerOut);
          }
          if (pieChartOut) {
            if (pieChartOut == 'slide-to-left') {
              if (pieChartOverlay.classList.value.indexOf('chart-in-left') > -1) {
                chartSlideToRight();

                if (getOS() == 'Windows') {
                  colourSideLeft.classList.remove('fade-out-top');
                }
              } else {
                if (getOS() == 'Windows') {
                  if (pieChartOverlay.classList.value.indexOf('slide-to-left-windows') > -1) {
                    chartSlideToLeft();
                  }
                  if (pieChartOverlay.classList.value.indexOf('slide-to-left-windows') == -1) {
                    pieChartOverlay.classList.add('slide-to-left-windows');
                    colourSideLeft.classList.remove('fade-out-top');
                  }
                } else {
                  chartSlideToLeft();
                }
              }
            }
            if (pieChartOut == 'slide-to-top') {
              pieChartOverlay.classList.add(pieChartOut);
              pieChartOverlay.classList.add('chart-in-left');

              if (getOS() == 'Windows') {
                colourSideRight.classList.remove('fade-out-top');
              }
            }
          } else {
            pieChartOverlay.classList.add('fade-out');
          }
        }, 0);
      } else if (scrollTop < columnsActiveOffsetTop && columnsActive) {
        var colourCorner = columnsActive.dataset['colourCorner'];
        var colourCornerOut = columnsActive.dataset['colourCornerOut'];
        colourCornerLeft.classList.add('fade-out');

        setTimeout(function () {
          if (colourCorner == 'true') {
            colourCornerLeft.classList.add('active');
          } else {
            colourCornerLeft.classList.remove('active');
          }
          if (colourCornerOut) {
            colourCornerLeft.classList.add(colourCornerOut);
          }
        }, 0);
      } else if (columnsActive) {
        setTimeout(function () {
          columnsActive.classList.remove('fade-out');
          colourCornerLeft.classList.remove('fade-out');
          colourSideLeft.classList.remove('fade-out');
          colourSideLeft.classList.remove('fade-out-top');
          colourSideRight.classList.remove('fade-out');
          colourSideRight.classList.remove('fade-out-top');
          pieChartOverlay.classList.remove('fade-out');
          pieChartOverlay.classList.remove('fade-out-top');
        }, 0);
      }

      window.scrollTo(0, yCoord);
    });
  }

  function initResetAnimation() {
    var sections = scrollSnapContainer.querySelectorAll('.section');

    sections.forEach((section) => {
      section.classList.remove('fade-out');
    });
  }

  function chartSlideToRight() {
    clearTimeout(timeoutChartInRight);
    var pieChartOverlay = blockSectionScrollSnap.querySelector('.pie-chart-overlay');
    pieChartOverlay.classList.add('slide-to-right');
    timeoutChartInRight = setTimeout(function () {
      pieChartOverlay.classList.add('no-animation-slide-in-bottom');
      pieChartOverlay.classList.add('chart-in-right');
      pieChartOverlay.classList.remove('chart-in-left');
      pieChartOverlay.classList.remove('slide-to-right');

      var columnsActive = scrollSnapContainer.querySelector('.section.active');
      var pieChartPosition = columnsActive.dataset['pieChartPosition'];
      if (pieChartPosition == 'chart-in-left') {
        pieChartOverlay.classList.remove('active');
        chartSlideToLeftFast();
      }
    }, 1500);
    pieChart3.series[0].update({
      data: dataPieChartRight
    });
  }

  function chartSlideToLeft() {
    clearTimeout(timeoutChartInLeft);
    var pieChartOverlay = blockSectionScrollSnap.querySelector('.pie-chart-overlay');
    pieChartOverlay.classList.add('slide-to-left');
    timeoutChartInLeft = setTimeout(function () {
      pieChartOverlay.classList.add('no-animation-slide-in-bottom');
      pieChartOverlay.classList.add('chart-in-left');
      pieChartOverlay.classList.remove('chart-in-right');
      pieChartOverlay.classList.remove('slide-to-left');

      if (getOS() == 'Windows') {
        pieChartOverlay.classList.remove('slide-to-left-windows');
        pieChartOverlay.classList.remove('fade-out-top');
      }

      var columnsActive = scrollSnapContainer.querySelector('.section.active');
      var pieChartPosition = columnsActive.dataset['pieChartPosition'];
      if (pieChartPosition == 'chart-in-right') {
        pieChartOverlay.classList.remove('active');
        chartSlideToRightFast();
      }
    }, 1500);
    pieChart3.series[0].update({
      data: dataPieChartLeft
    });
  }

  function chartSlideToRightFast() {
    clearTimeout(timeoutChartInRightFast);
    var pieChartOverlay = blockSectionScrollSnap.querySelector('.pie-chart-overlay');
    pieChartOverlay.classList.add('active');
    pieChartOverlay.classList.add('slide-to-right-fast');
    timeoutChartInRightFast = setTimeout(function () {
      pieChartOverlay.classList.add('no-animation-slide-in-bottom');
      pieChartOverlay.classList.add('chart-in-right');
      pieChartOverlay.classList.remove('chart-in-left');
      pieChartOverlay.classList.remove('slide-to-right-fast');
    }, 1500);
    pieChart3.series[0].update({
      data: dataPieChartRight
    });
  }

  function chartSlideToLeftFast() {
    clearTimeout(timeoutChartInLeftFast);
    var pieChartOverlay = blockSectionScrollSnap.querySelector('.pie-chart-overlay');
    pieChartOverlay.classList.add('active');
    pieChartOverlay.classList.add('slide-to-left-fast');
    timeoutChartInLeftFast = setTimeout(function () {
      pieChartOverlay.classList.add('no-animation-slide-in-bottom');
      pieChartOverlay.classList.add('chart-in-left');
      pieChartOverlay.classList.remove('chart-in-right');
      pieChartOverlay.classList.remove('slide-to-left-fast');
    }, 1500);
    pieChart3.series[0].update({
      data: dataPieChartLeft
    });
  }
  function getOS() {
    const userAgent = window.navigator.userAgent,
      platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
      macosPlatforms = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (/Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  }

  let lastScrollTop = 0;
  let wheelEventEndTimeout = null;
  scrollSnapContainer.addEventListener(
    'wheel',
    function () {
      clearTimeout(wheelEventEndTimeout);
      wheelEventEndTimeout = setTimeout(() => {
        let currentScroll = this.scrollTop;
        var columnsActive = scrollSnapContainer.querySelector('.section.active');

        if (currentScroll >= lastScrollTop && currentScroll > 0) {
          if (columnsActive && columnsActive.classList.value.indexOf('section--last') > -1) {
            document.body.classList.remove('scroll-overflow-hidden');
          }
        } else {
          if (columnsActive && columnsActive.classList.value.indexOf('section--first') > -1) {
            document.body.classList.remove('scroll-overflow-hidden');
          }
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      }, 10);
    },
    { passive: false }
  );

  initAddAnimationDelay();
  initSetSectionActive();
  initOnScrollAnimation();

  window.addEventListener('resize', (event) => {
    initResetAnimation();
  });
}
